import { render } from "./ReportStatusDropdownItem.vue?vue&type=template&id=04cb3096"
import script from "./ReportStatusDropdownItem.vue?vue&type=script&lang=js"
export * from "./ReportStatusDropdownItem.vue?vue&type=script&lang=js"

import "./ReportStatusDropdownItem.vue?vue&type=style&index=0&id=04cb3096&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__